import { colors } from "./constants";

export const indexToColor = (idx: number): string =>
    colors[(idx - 1) % colors.length];
